var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agent-info-card mt-2 pa-7 rounded-xl"},_vm._l((_vm.cardData),function(ref,idx){
var title = ref.title;
var description = ref.description;
return _c('div',{key:("" + title + idx),staticClass:"agent-info-card__info-wrapper"},[_c('item-info',{attrs:{"title":title,"description":description}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }